import { Amplify } from 'aws-amplify';
import { sharedInMemoryStorage } from 'aws-amplify/utils';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID!,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID!,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_AUTH_DOMAIN!,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [process.env.REACT_APP_REDIRECT_SIGNIN!],
          redirectSignOut: [process.env.REACT_APP_REDIRECT_SIGNOUT!],
          responseType: 'code'
        }
      }
    }
  },
  storage: sharedInMemoryStorage
});
